module.exports = __webpack_public_path__ + "img/logo1.e48ebc85.jpg";